import React from 'react';
import { createSvgIcon } from '../utils/createSvgIcon';

export const Info = createSvgIcon(
  () => (
    <path d="M1.25739 20.8018C0.694885 20.8018 0.319885 21.2236 0.319885 21.7393V23.9424C0.319885 24.5049 0.694885 24.8799 1.25739 24.8799H8.38238C8.89801 24.8799 9.31988 24.5049 9.31988 23.9424V21.7393C9.31988 21.2236 8.89801 20.8018 8.38238 20.8018H7.44488V10.8174C7.44488 10.3018 7.02301 9.87988 6.50738 9.87988H1.25739C0.694885 9.87988 0.319885 10.3018 0.319885 10.8174V13.0674C0.319885 13.583 0.694885 14.0049 1.25739 14.0049H2.19489V20.8018H1.25739ZM4.81988 0.879883C2.94489 0.879883 1.44489 2.42676 1.44489 4.25488C1.44489 6.12988 2.94489 7.62988 4.81988 7.62988C6.64801 7.62988 8.19488 6.12988 8.19488 4.25488C8.19488 2.42676 6.64801 0.879883 4.81988 0.879883Z" />
  ),
  '0 0 10 25'
);
